export const layout = {
  layout_navTab_invite: 'Inviter',
  layout_navTab_calendar: 'Calendrier',
  layout_navTab_questionnaires: 'Questionnaires',
  layout_navTab_profile: 'Profil',
  layout_navTab_study: 'Etude',
};
 